import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Loader from "../../../components/Loader";
import formatPrice from "../../../utils/formatCloverPrice";
import backendAPI from "../../../utils/backendAPI";
import { useTranslation } from "react-i18next";

function CustomerLoyalty() {
  const [customerData, setCustomerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showHistory, setShowHistory] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCustomerData = async () => {
      setLoading(true);

      try {
        const res = await backendAPI.get(`/api/clover/customer-loyalty/`);
        if (res.status === 200) {
          console.log(res.data);
          setCustomerData(res.data);
        }
      } catch (e) {
        console.log("Error Fetching Data:", e);
        setCustomerData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerData();
  }, []);

  const toggleHistory = (customerId) => {
    setShowHistory((prevState) => ({
      ...prevState,
      [customerId]: !prevState[customerId],
    }));
  };

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          <br />
          <div className="page-title-and-bnt">
            <h1>{t("customerLoyalty.header")}</h1>
          </div>
          <br />

          {loading ? (
            <Loader />
          ) : (
            <>
              {customerData.length > 0 ? (
                customerData.map((customer) => (
                  <div key={customer.customer_id}>
                    <h2>
                      {t("merchantsData.paymentDetail.customerID")}:{" "}
                      {customer.customer_id}
                    </h2>
                    <h3>
                      {t("customerLoyalty.totalPoints")}:{" "}
                      {customer.total_points}
                    </h3>
                    <Button onClick={() => toggleHistory(customer.customer_id)}>
                      {showHistory[customer.customer_id]
                        ? t("customerLoyalty.hidePurchaseHistory")
                        : t("customerLoyalty.showPurchaseHistory")}
                    </Button>
                    {showHistory[customer.customer_id] && (
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>{t("merchantsData.paymentDetail.orderID")}</th>
                            <th>{t("customerLoyalty.title")}</th>
                            <th>{t("merchantsData.paymentDetail.Total")}</th>
                            <th>{t("customerLoyalty.paymentState")}</th>
                            <th>{t("customerLoyalty.createdTime")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customer.purchase_history.map((order) => (
                            <tr key={order.id}>
                              <td>{order.id}</td>
                              <td>{order.title}</td>
                              <td>{formatPrice(order.total)}</td>
                              <td>{order.paymentState}</td>
                              <td>
                                {new Date(order.createdTime).toLocaleString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                    <br />
                  </div>
                ))
              ) : (
                <p>{t("customerLoyalty.nodata")}</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerLoyalty;
